import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import {
  Table,
  Typography,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Row,
  Col,
  Divider,
} from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import HeaderBox from '../../components/Loader/Header';
import axios from 'axios';
import { baseUrl } from '../../common/constants';
import Loading from '../../components/Loader/Loading';
import ReusableDropdown from '../Doctors/ReuseableArrowDropDown';
import EditAdjusterModal from '../../modals/EditAdjusterModal';
import AdjusterModal from '../../modals/AdjusterModal';

const { Text } = Typography;

const AdjusterList = () => {
  const { id } = useParams(); 
  const location = useLocation();
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search);
  const companyName = queryParams.get('companyName');
  const [adjusters, setAdjusters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdjusterModalOpen, setIsAdjusterModalOpen] = useState(false);
  const [selectedAdjusterId, setSelectedAdjusterId] = useState(null);
  const [isEditAdjusterModalOpen, setIsEditAdjusterModalOpen] = useState(false);

  const fetchAdjusters = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${baseUrl}/insurance/${id}/adjusters`);
      let adjusters = response?.data?.payload?.message ? [] : response.data.payload
      setAdjusters(adjusters);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching adjusters:', error);
    }
  };

  useEffect(() => {
    fetchAdjusters();
  }, [id]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const openEditAdjusterForm = (parentId) => {
    setSelectedAdjusterId(parentId);
    setIsEditAdjusterModalOpen(true);
  };

  const closeEditAdjusterForm = () => {
    setIsEditAdjusterModalOpen(false);
  };

  const openNewAdjusterModal = () => {
    setIsAdjusterModalOpen(true);
  };

  const closeNewAdjusterModal = () => {
    setIsAdjusterModalOpen(false);
  };

    const closeOfficeEditForm = () => {
      fetchAdjusters();
    setIsEditAdjusterModalOpen(false);
  };

  const updateAdjusterList = () => {
    fetchAdjusters();
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <ReusableDropdown
          options={[
            {
              label: 'Edit Adjuster',
              onClick: () => openEditAdjusterForm(record.id),
            },
          ]}
          parentId={record.id}
        />
      ),
    },
  ];

  return (
    <div>
      {isLoading && <Loading />}
      <Row justify="center">
        <Col xs={24} md={16}>
          <HeaderBox text={`${companyName} Adjusters`} onBackClick={handleGoBack}>
            <Button type="primary" onClick={openNewAdjusterModal} icon={<PlusOutlined />}>
              New Adjuster
            </Button>
          </HeaderBox>
          <Table
            dataSource={adjusters}
            columns={columns}
            rowKey="id"
            bordered
            pagination={false}
            locale={{emptyText:adjusters?.message}}
          />
        </Col>
      </Row>
      <EditAdjusterModal
        open={isEditAdjusterModalOpen}
        handleClose={closeOfficeEditForm}
        parentId={id}
        currentUserId={selectedAdjusterId}
      />
      <AdjusterModal
        open={isAdjusterModalOpen}
        handleClose={closeNewAdjusterModal}
        parentId={id}
        onSubmit={updateAdjusterList}
      />
    </div>
  );
};

export default AdjusterList;

